/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Mixin to provide model-field level permissions on the serializer level.
 * 
 * How to use:
 *     1. Add the mixin as the first inherited class to your serializer (at
 *        least before the SerializerExtensionsMixin).
 *     2. Make sure that Meta.model is specified on your serializer.
 *     3. Define a 'get_forbidden_fields' classmethod on the according model
 *        class that returns a list of fieldnames for all fields that a user
 *        is *not* allowed to view/edit. Example:
 * 
 *             @classmethod
 *             def get_forbidden_fields(cls, action: Literal["view", "create", "edit"],
 *                                      user) -> List[str]:
 *                 if action == "view":
 *                     if user.is_staff: return []
 * 
 *                     # for all other users
 *                     return [
 *                         "forbidden_field_name_1",
 *                         "forbidden_field_name_2,
 *                     ]
 *                 if action == "create":
 *                     pass
 *                 if action == "edit":
 *                     pass
 *                 return []
 * 
 * 
 * How to use with expandable fields:
 *     1. Setup the HyperlinkedRelatedField as usual.
 *     2. Add the field that relies on you permission-enriched serializer to
 *        the 'expandable_fields' dict and point it to 'SerializerMethodField'.
 *        (from rest_framework.serializers import SerializerMethodField)
 *     3. Add a serializer method with the name 'get_<expandable_field_name>'
 *        to the serializer that holds the expandable field.
 * 
 *     Example:
 * 
 *             class SerializerB( FieldLevelPermissionSerializerMixin,
 *                                SerializerExtensionMixin,
 *                                HyperlinkedModelSerializer):
 *                 class Meta:
 *                     model=B
 * 
 *             class SerializerA(SerializerExtensionMixin, HyperlinkedModelSerializer):
 *                 field_b = HyperlinkedRelatedField(
 *                     view_name="View-B-detail",
 *                     ...
 *                 )
 * 
 *                 get_field_b(self, obj):
 *                     "   Helper method that provides the nested serializer
 *                         SerializerB with the required information for
 *                         the FieldLevelPermissionSerializerMixin to work.
 *                        "
 *                     return SerializerB(context={
 *                         "request": self.context["request"],
 *                         "view": self.context["view"],
 *                         "expand": [
 *                             # prepare the argument for the next serializer
 *                             expand_arg.removeprefix("field_b__")
 *                             for expand_arg
 *                             in self.context["expand"]
 *                             # remove any arguments that are meant for the current serializer
 *                             if expand_arg.startswith("field_b__")
 *                         ],
 *                     }).to_representation(obj.field_b)
 * 
 *                 class Meta:
 *                     model=A
 *                     expandable_fields=dict(
 *                         field_a=SerializerMethodField
 *                     )
 * @export
 * @interface APIGuestRequest
 */
export interface APIGuestRequest {
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequest
     */
    readonly self: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIGuestRequest
     */
    editors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequest
     */
    readonly files: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIGuestRequest
     */
    readonly read: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequest
     */
    company: string;
    /**
     * Quantities listed as string and separated by comma like '1,2,3'
     * @type {string}
     * @memberof APIGuestRequest
     */
    quantity: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequest
     */
    material: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequest
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequest
     */
    remarks?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIGuestRequest
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequest
     */
    status?: string | null;
}

/**
 * Check if a given object implements the APIGuestRequest interface.
 */
export function instanceOfAPIGuestRequest(value: object): value is APIGuestRequest {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    if (!('read' in value) || value['read'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('material' in value) || value['material'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function APIGuestRequestFromJSON(json: any): APIGuestRequest {
    return APIGuestRequestFromJSONTyped(json, false);
}

export function APIGuestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'files': json['files'],
        'read': json['read'],
        'name': json['name'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'company': json['company'],
        'quantity': json['quantity'],
        'material': json['material'],
        'message': json['message'] == null ? undefined : json['message'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'createdAt': (new Date(json['created_at'])),
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function APIGuestRequestToJSON(value?: Omit<APIGuestRequest, 'self'|'files'|'read'|'created_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'editors': value['editors'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'company': value['company'],
        'quantity': value['quantity'],
        'material': value['material'],
        'message': value['message'],
        'remarks': value['remarks'],
        'status': value['status'],
    };
}

